var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47456 9.02293C12.365 5.25469 17.0514 3.37061 22.5333 3.37061C28.0152 3.37061 32.6793 5.23329 36.5255 8.95872C40.3721 12.6842 42.2951 17.2017 42.2951 22.5115C42.2951 25.1663 41.6098 28.2066 40.2392 31.6324C38.8687 35.0579 37.2108 38.2696 35.2656 41.267C33.3205 44.2644 31.3975 47.0691 29.4964 49.6813C27.5953 52.2935 25.9816 54.37 24.6554 55.9117L22.5333 58.0956C22.0027 57.496 21.2953 56.704 20.4112 55.719C19.5271 54.7342 17.9355 52.7645 15.6365 49.8096C13.3376 46.8551 11.3261 43.9863 9.60189 41.2029C7.87772 38.4195 6.30827 35.2722 4.89357 31.7607C3.47883 28.2495 2.77148 25.1663 2.77148 22.5115C2.77148 17.2017 4.67248 12.7056 8.47456 9.02293Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5737 23.1321C25.5737 24.8112 24.2126 26.1723 22.5334 26.1723C20.8543 26.1723 19.4932 24.8112 19.4932 23.1321C19.4932 21.453 20.8543 20.0918 22.5334 20.0918C24.2126 20.0918 25.5737 21.453 25.5737 23.1321Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9d073d12a6a3a45e9c068ab3ffccb516.svg";
export { ForwardRef as ReactComponent };